import type { ReactNode } from 'react'
import { Flex, Typography } from 'antd'

type PageHeaderProps = {
  title: string
  description?: string
  icon?: ReactNode
  extra?: ReactNode
}

export function PageHeader({ title, description, icon, extra }: PageHeaderProps) {
  return (
    <Flex className="page-header" align="center" justify="space-between" gap="middle" wrap>
      <Flex align="center" gap="middle">
        {icon && <div className="page-header-icon">{icon}</div>}
        <div>
          <Typography.Title level={3} className="page-title">
            {title}
          </Typography.Title>
          {description && (
            <Typography.Text type="secondary">
              {description}
            </Typography.Text>
          )}
        </div>
      </Flex>
      {extra && <div className="page-header-extra">{extra}</div>}
    </Flex>
  )
}
